<template>
  <div class="navigation">
    <v-icon
      v-if="$vuetify.breakpoint.smAndDown"
      @click="$emit('showDrawer')"
      class="mr-2 pa-1"
    >
      menu
    </v-icon>
    <NavigationButtons v-else />
  </div>
</template>
<script>
import NavigationButtons from './NavigationButtons';

export default {
  name: 'Navigation',
  components: {
    NavigationButtons,
  },
};
</script>

<style scoped>
.navigation {
  height: 100%;
  display: flex;
  align-items: center;
}
</style>
